// extracted by mini-css-extract-plugin
export default {"banner":"BgImage_banner__bga+t","tags":"BgImage_tags__WYhWi"};